import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, Input, Typography } from "@mui/material";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import DataTableItem from "react-data-table-component";
import { useOutletContext, useParams } from "react-router-dom";
import localizationStrings from "../utils/localizations";
import { baseUrl } from "./../utils/constants";

// const formatTime = (mins) => {
//   const date = moment.utc(Math.abs(mins) * 60 * 1000);
//   // return date;
//   if (date.valueOf() > moment.utc(24 * 60 * 60 * 1000).valueOf()) {
//     var retVal = date.format('DD [days] HH [hr] mm [min]');
//   } else if (date.valueOf() > moment.utc(60 * 60 * 1000).valueOf()) {
//     var retVal = date.format('HH [hr] mm [min]');
//   } else {
//     var retVal = date.format('mm [min]');
//   }
//   return retVal.replace('days', localizationStrings.days).replace('hr', localizationStrings.hrs).replace('min', localizationStrings.min);
//   // [localizationStrings.getLanguage() == 'ar' ? 'toArabic' : 'toString']();
// };

function secondsToDhms(seconds) {
  seconds = Number(seconds);
  var sign = seconds < 0 ? "-" : "";
  seconds = Math.abs(seconds);
  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor((seconds % (3600 * 24)) / 3600);
  var m = Math.floor((seconds % 3600) / 60);

  var dDisplay = d > 0 ? d + ` ${localizationStrings.days} ` : "";
  var hDisplay = h > 0 ? h + ` ${localizationStrings.hrs} ` : "";
  var mDisplay = m > 0 && d <= 0 ? m + ` ${localizationStrings.min} ` : "";
  return (sign + dDisplay + hDisplay + mDisplay).trim() || `0 ${localizationStrings.min}`;
}

const formatTime = (mins) => {
  return secondsToDhms(mins * 60);
};
export default function Houses() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const { LeavingNo } = useParams();

  const getEmployees = async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      const data = await axios.get(baseUrl + "getHouses/" + LeavingNo);
      if (data.data.status) {
        setData(data.data.result);
        setFilteredData(data.data.result);

        setTimeout(() => {
          document.getElementsByClassName("rdt_Pagination")[0].dir = "ltr";
          // document.getElementsByClassName('rdt_Pagination')[0].children[0].innerText = localizationStrings.RowsPerPage;
        }, 1000);
      }
      if (!silent) setLoading(false);
    } catch (e) {
      if (!silent) setLoading(false);
      console.warn(e);
    }
  };
  useEffect(() => {
    getEmployees();
    const int = setInterval(() => {
      getEmployees(true);
    }, 30 * 1000);
    return () => clearInterval(int);
  }, []);

  const formatDateTime = (time, doUtc = true) => {
    if (doUtc) {
      return moment(time).utc().format("DD/MM/YYYY HH:mm");
    }
    return moment(time).format("DD/MM/YYYY HH:mm");
  };

  if (loading) {
    return (
      <div className="tracking-container" style={{ alignItems: "center", justifyContent: "center" }}>
        <div className="loader"></div>
      </div>
    );
  }
  if (data.length == 0) {
    return (
      <div className="tracking-container" style={{ alignItems: "center", justifyContent: "center" }}>
        <h3 style={{ textAlign: "center" }}>{localizationStrings.NoTrips}</h3>
      </div>
    );
  }

  const handleSearch = () => {
    setFilteredData(
      data.filter((v) =>
        (
          JSON.stringify(v) +
          (moment(v.StartDatetime).utc().diff(moment(v.LeavingDate).utc(), "minute") < 0 ? "-" : "") +
          (v.StartDatetime
            ? formatTime(moment(v.StartDatetime).utc().diff(moment(v.LeavingDate).utc(), "minute"))
            : localizationStrings.NotStarted) +
          formatDateTime(v.LeavingDate) +
          (v.StartDatetime ? formatDateTime(v.StartDatetime) : localizationStrings.NotStarted) +
          (v.EndDatetime ? formatDateTime(v.EndDatetime) : "Under Progress") +
          (v.StartDatetime
            ? formatTime(
                moment(v.StartDatetime)
                  .utc()
                  .diff(v.EndDatetime ? moment(v.EndDatetime).utc() : moment().utc(), "minute"),
              )
            : localizationStrings.NotStarted)
        )
          .toLocaleLowerCase()
          .includes(search.toLocaleLowerCase()),
      ),
    );
  };

  return (
    <div style={{ height: "calc(100vh - 80px)", width: "100%", padding: 30 }}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
      >
        <Typography sx={{ fontWeight: "700" }}>{LeavingNo}</Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            mb: "15px",
          }}
        >
          {/* <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={exporting ? null : exportPdf}>
            <DownloadIcon fontSize='11px' />
            <Typography sx={{ fontSize: 12, fontWeight: '500', marginLeft: '5px' }}>
              {exporting ? localizationStrings.Exporting + '...' : localizationStrings.ExportToExcel}
            </Typography>
          </Box> */}
          <div style={{ flex: 1, display: "flex" }} />
          <Input
            style={{ backgroundColor: "#fff" }}
            placeholder={localizationStrings.Search}
            color="primary"
            value={search}
            onChange={(e) => setSearch(e.nativeEvent.target.value)}
            endAdornment={
              <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <IconButton
                  onClick={() => {
                    setFilteredData(data);
                    setSearch("");
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <IconButton type="submit" onClick={handleSearch}>
                  <SearchIcon />
                </IconButton>
              </Box>
            }
          />
        </Box>
      </form>
      <DataTableItem
        data={filteredData}
        columns={[
          {
            selector: (row) => row.LeavingNo,
            name: <div>{localizationStrings.LeavingNo}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => formatDateTime(row.LeavingDate),
            name: <div>{localizationStrings.LeavingDate}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => formatDateTime(row.created_at, false),
            name: <div>{localizationStrings.StationArriveDate}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => row.HouseName,
            name: <div>{localizationStrings.LocationName}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => row.Est_Name,
            name: <div>{localizationStrings.HajjCompany}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },

          {
            selector: (row) => (row.StartDatetime ? formatDateTime(row.StartDatetime) : localizationStrings.NotStarted),
            name: <div>{localizationStrings.StartDate}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },

          {
            selector: (row) =>
              row.StartDatetime
                ? formatTime(moment(row.StartDatetime).diff(moment(row.created_at).utc(), "minute"))
                : localizationStrings.NotStarted,
            name: <div>{localizationStrings.TimeToStart}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },

          {
            selector: (row) => (row.EndDatetime ? formatDateTime(row.EndDatetime) : localizationStrings.NotEnded),
            name: <div>{localizationStrings.ArriveDate}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => (row.PickupTime ? formatDateTime(row.PickupTime) : localizationStrings.NotPickedUp),
            name: <div>{localizationStrings.PickupTime}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) =>
              row.StartDatetime
                ? row.EndDatetime
                  ? formatTime(
                      moment(row.StartDatetime)
                        .utc()
                        .diff(row.EndDatetime ? moment(row.EndDatetime).utc() : moment().utc(), "minute") * -1,
                    )
                  : localizationStrings.NotEnded
                : localizationStrings.NotStarted,
            name: <div>{localizationStrings.TimeToArrive}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => (
              <a href={`https://maps.google.com/?q=${row.Latitude},${row.Longitude}`} target="_blank">
                <Typography>Open Google Map</Typography>
              </a>
            ),
            name: <div>{localizationStrings.TimeToArrive}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
        ]}
        highlightOnHover
        fixedHeader
        pagination
        responsive
        style={{ height: "calc(100vh - 82px)" }}
        customStyles={{
          headCells: { style: { backgroundColor: "#E8DABC", color: "#000", fontSize: "11px" } },
          responsiveWrapper: {
            style: {
              height: "calc(100vh - 220px)",
            },
          },
          cells: {
            style: {
              fontSize: "11px",
            },
          },
        }}
        paginationComponent={({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage }) => (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              minHeight: 56,
            }}
          >
            <Typography sx={{ margin: "0 24px", color: "rgba(0, 0, 0, 0.54)", fontSize: "13px" }}>
              {(currentPage - 1) * rowsPerPage + 1}-
              {currentPage * rowsPerPage > rowCount ? rowCount : currentPage * rowsPerPage} of {rowCount}
            </Typography>
            <div style={{ display: "flex", alignItems: "center" }}>
              <button
                className="changeButton"
                type="button"
                disabled={currentPage == 1}
                style={{
                  fill: `rgba(0,0,0,${currentPage == 1 ? "0.18" : "0.54"})`,
                  color: `rgba(0,0,0,${currentPage == 1 ? "0.18" : "0.54"})`,
                }}
                onClick={() => onChangePage(1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  role="presentation"
                >
                  <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
                  <path fill="none" d="M24 24H0V0h24v24z"></path>
                </svg>
              </button>
              <button
                className="changeButton"
                type="button"
                disabled={currentPage == 1}
                style={{
                  fill: `rgba(0,0,0,${currentPage == 1 ? "0.18" : "0.54"})`,
                  color: `rgba(0,0,0,${currentPage == 1 ? "0.18" : "0.54"})`,
                }}
                onClick={() => onChangePage(currentPage - 1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  role="presentation"
                >
                  <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                  <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
              </button>
              <button
                className="changeButton"
                type="button"
                disabled={currentPage == Math.ceil(rowCount / rowsPerPage)}
                style={{
                  fill: `rgba(0,0,0,${currentPage == Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  color: `rgba(0,0,0,${currentPage == Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                }}
                onClick={() => onChangePage(currentPage + 1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  role="presentation"
                >
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                  <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
              </button>
              <button
                className="changeButton"
                type="button"
                disabled={currentPage == Math.ceil(rowCount / rowsPerPage)}
                style={{
                  fill: `rgba(0,0,0,${currentPage == Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  color: `rgba(0,0,0,${currentPage == Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                }}
                onClick={() => onChangePage(Math.ceil(rowCount / rowsPerPage))}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  role="presentation"
                >
                  <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
                  <path fill="none" d="M0 0h24v24H0V0z"></path>
                </svg>
              </button>
            </div>
          </Box>
        )}
      />
    </div>
  );
}
